export default __webpack_public_path__ + "static/media/Lato-Regular.9919edff.ttf";